import ky from "ky";

const getEnvironment = () => {
    const hostname = window.location.hostname;

    switch (hostname) {
        case "192.168.1.5":
            return "development";
        case "app.orderwerks.com":
            return "prod";
        case "test-api.orderwerks.com":
        case "test-app.orderwerks.com":
        case "staging-app.orderwerks.com":
            return "test";
        case "localhost":
        case "127.0.0.1":
            // Check if running in Docker container
            return window.location.port === "80" ? "docker" : "development";
        default:
            return "development";
    }
};

const getEndpointUrl = () => {
    const hostname = window.location.hostname;
    console.log("hostname", hostname);
    const endpointMap: Record<string, string> = {
        "192.168.1.5": "http://192.168.1.5:3000",
        "app.orderwerks.com": "https://api.orderwerks.com",
        "test-api.orderwerks.com": "https://test-api.orderwerks.com",
        "test-app.orderwerks.com": "https://test-api.orderwerks.com",
        "staging-app.orderwerks.com": "https://staging-api.orderwerks.com",
        "orderwerks-ui.ngrok.io": "https://orderwerks.ngrok.io",
    };

    // Handle Docker environment
    if (hostname === "localhost" && window.location.port === "80") {
        return "/api"; // Nginx will proxy this to the API container
    }

    return endpointMap[hostname] || `http://${hostname}:3000`;
};

const getApiEndpointURl = () => {
    const hostname = window.location.hostname;

    const endpointMap: Record<string, string> = {
        "192.168.1.5": "http://192.168.1.5:3000",
        "app.orderwerks.com": "https://owapi.orderwerks.com",
        "test-api.orderwerks.com": "https://test-api.orderwerks.com",
        "test-app.orderwerks.com": "https://test-api.orderwerks.com",
        "staging-app.orderwerks.com": "https://staging-api.orderwerks.com",
        "orderwerks-ui.ngrok.io": "https://orderwerks.ngrok.io",
    };

    // Handle Docker environment
    if (hostname === "localhost" && window.location.port === "80") {
        return "/api"; // Nginx will proxy this to the API container
    }

    return endpointMap[hostname] || `http://${hostname}:3000`;
};

const getUIUrl = () => {
    const hostname = window.location.hostname;

    const endpointMap: Record<string, string> = {
        "app.orderwerks.com": "https://app.orderwerks.com",
        "test-api.orderwerks.com": "https://test-api.orderwerks.com",
        "test-app.orderwerks.com": "https://test-app.orderwerks.com",
        "staging-app.orderwerks.com": "https://staging-app.orderwerks.com",
        "orderwerks-ui.ngrok.io": "https://orderwerks-ui.ngrok.io",
    };

    return endpointMap[hostname] || `http://${hostname}:3001`;
};

const getStaticSiteUrl = (): string => {
    const hostname = window.location.hostname;

    const staticSiteMap: Record<string, string> = {
        "app.orderwerks.com": "https://www.orderwerks.com",
        "test-api.orderwerks.com": "https://test-api.orderwerks.com",
        "test.orderwerks.com": "https://test.orderwerks.com",
        "staging-app.orderwerks.com": "https://staging.orderwerks.com",
        "orderwerks-ui.ngrok.io": "https://localhost:8080",
    };

    return staticSiteMap[hostname] || `http://${hostname}:8080`;
};

const getAuthUrl = () => {
    const hostname = window.location.hostname;
    console.log("hostname", hostname);
    const endpointMap: Record<string, string> = {
        "192.168.1.5": "http://192.168.1.5:3000",
        "app.orderwerks.com": "https://auth.orderwerks.com",
        "test-api.orderwerks.com": "https://test-api.orderwerks.com",
        "test-app.orderwerks.com": "https://test-api.orderwerks.com",
        "staging-app.orderwerks.com": "https://staging-api.orderwerks.com",
        "orderwerks-ui.ngrok.io": "https://orderwerks.ngrok.io",
    };

    // Handle Docker environment
    if (hostname === "localhost" && window.location.port === "80") {
        return "/api"; // Nginx will proxy this to the API container
    }

    return endpointMap[hostname] || `http://${hostname}:3000`;
};

const isOnline = (): Promise<boolean> => {
    return new Promise((resolve) => {
        // perform an api call (HEAD?) against an ok url.
        const url = `${getUIUrl()}/favicon.ico`;

        ky.head(url).then(
            () => {
                // console.log("success", success);
                resolve(true);
            },
            (error: any) => {
                console.log("error", error);
                resolve(false);
            }
        );
    });
};

const SocketService = {
    getEndpointUrl,
    getUIUrl,
    isOnline,
    getStaticSiteUrl,
    getApiEndpointURl,
    getEnvironment,
    getAuthUrl,
};

export default SocketService;
